import React, { lazy } from "react"
import { NEW_TASK_VIEW, TASKS_LIST_VIEW } from "./route-list"
import TasksTab from "@/features/tasks/views/tasks-tab/tasks-tab.tsx"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const NewTaskView = lazy(
  () => import("@/features/tasks/views/new-task-view/new-task-view"),
)
const TaskView = lazy(
  () => import("@/features/tasks/views/task-view/task-view"),
)
const BottomMenuLayout = React.lazy(
  () => import("@/layouts/bottom-menu-layout/bottom-menu-layout.tsx"),
)

export const noMenuLayoutTasksRoutes = [
  {
    path: `${NEW_TASK_VIEW}/:animalId`,
    element: <NewTaskView />,
  },
  {
    path: NEW_TASK_VIEW,
    element: <NewTaskView />,
  },
  {
    path: `${TASKS_LIST_VIEW}/:taskId`,
    element: <TaskView />,
  },
]

export const bottomMenuLayoutTaskRoutes = [
  {
    path: TASKS_LIST_VIEW,
    element: <TasksTab />,
  },
]

export const MOBILE_NO_MENU_TASKS_ROUTES = {
  element: <NoMenuLayout />,
  children: noMenuLayoutTasksRoutes,
}

export const MOBILE_BOTTOM_MENU_TASKS_ROUTES = {
  element: <BottomMenuLayout />,
  children: bottomMenuLayoutTaskRoutes,
}

const MOBILE_TASKS_ROUTES = [
  MOBILE_NO_MENU_TASKS_ROUTES,
  MOBILE_BOTTOM_MENU_TASKS_ROUTES,
]

const DESKTOP_TASKS_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: [...bottomMenuLayoutTaskRoutes, ...noMenuLayoutTasksRoutes],
  },
]

export const getTasksRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_TASKS_ROUTES : MOBILE_TASKS_ROUTES
}
